import { FaInstagram, FaFacebook, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const socialLinks = [
  { label: 'Instagram', href: 'https://www.instagram.com/manvidia_official/', Icon: FaInstagram },
  { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61573160758204', Icon: FaFacebook },
  { label: 'X (Twitter)', href: 'https://x.com/manvidia?t=R5lC-5T_PJTuDj_AgEN47A&s=08', Icon: FaXTwitter },
  { label: 'LinkedIn', href: 'https://linkedin.com/company/manvidia-ai', Icon: FaLinkedinIn },
];

export default socialLinks;
